// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { ActivitySpinnerSize, ActivitySpinnerWidget, DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import React from 'react';
import { connect, Dispatch } from 'react-redux';

import { Messages } from '../../../codegen/Localize';
import { ExtractEncryptionState } from '../../../datasource/models/IDataSourceInfo';
import { DataSources } from '../../../datasource/resources/Datasources';
import { IDatasourceActions } from '../../../datasource/ServerApi/types/IDatasourceActions';
import { ExtractEncryptionMode } from '../../../sites/SitePropertyTypes';
import { ISpaceItemDetailInfo } from '../../../ts/models/ISpaceItemDetailInfo';
import { IWorkbookActions } from '../../../workbook/ServerApi/types/IWorkbookActions';
import { cancelExtractAction } from '../../actions/spaces/CancelExtractTaskAction';
import { EncryptionActionType } from '../../actions/spaces/EncryptContentAction';
import { AppState } from '../../state/AppState';
import { SpaceHeaderStyles } from './SpaceHeaderStyles';

export enum ListItemValue {
  cancel = 'cancel extract action',
}

export class CancelExtractActionDropdown extends React.PureComponent<ICancelExtractActionDropdownProps, ICancelExtractActionDropdownState> {

  constructor(props: ICancelExtractActionDropdownProps) {
    super(props);
    this.state = {
      inProgress: false
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(value: ListItemValue): void {
    this.setState({
      inProgress: true
    });
    this.props.dispatchCancelExtractTaskAction(
      this.props.itemInfo,
      this.props.itemInfo.extractCreationPending,
      this.props.itemInfo.extractEncryptionState === ExtractEncryptionState.pendingEncryption ?
      EncryptionActionType.decryptExtracts : EncryptionActionType.encryptExtracts
    );
  }

  public render(): React.ReactNode {

    const cancelDropdownOptions: ListItem[] = [
      { value: ListItemValue.cancel, content: this.props.itemInfo.extractCreationPending ? Messages.cancelExtractCreation() :
        this.props.itemInfo.extractEncryptionState === ExtractEncryptionState.pendingEncryption ?
        Messages.cancelExtractEncryption() : Messages.cancelExtractDecryption()
      }
    ];

    /* eslint-disable jsx-a11y/anchor-is-valid */
    return (
      <span data-tb-test-id="cancel-extract-creation">
        <span key={1} className={SpaceHeaderStyles.ExtractStatusSpinner}>
          <ActivitySpinnerWidget testId="cancel-extract-creation" spinnerSize={ActivitySpinnerSize.Small} />
        </span>
        <SingleSelectDropdown className={SpaceHeaderStyles.ExtractStatusSelection}
              type={DropdownButtonType.Text}
              list={<List items={cancelDropdownOptions} />}
              onChange={this.onChange}
              disabled={this.state.inProgress}
              label={''}
            >
          <a key={2} className={SpaceHeaderStyles.headerLink}>{DataSources.DatasourceStatus(this.props.encryptionEnabled, this.props.connectionType,this.props.isFileBased,this.props.hasExtracts,
              this.props.extractEncryptionState, this.props.extractCreationPending, this.props.siteEARMode)}</a>
        </SingleSelectDropdown>
      </span>
    );
  }
}

type ICancelExtractActionDropdownState  = {
  inProgress: boolean;
};

type ICancelExtractActionDropdownOwnProps= {
  itemInfo: ISpaceItemDetailInfo<'workbook' | 'datasource'>;
  availableActions: IWorkbookActions | IDatasourceActions;
  disabled: boolean;
  hasExtracts: boolean;
  isFileBased?: boolean;
  connectionType?: string;
  encryptionEnabled: boolean;
  extractEncryptionState: ExtractEncryptionState;
  extractCreationPending: boolean;
  siteEARMode: ExtractEncryptionMode;
};

type ICancelExtractActionDropdownDispatchProps = {
  dispatchCancelExtractTaskAction?: (itemInfo: ISpaceItemDetailInfo<'workbook' | 'datasource'>, extractCreationPending: boolean, encryptionActionType?: EncryptionActionType) => void;
};

export type ICancelExtractActionDropdownProps = ICancelExtractActionDropdownOwnProps & ICancelExtractActionDropdownDispatchProps;

function mapDispatchToProps(dispatch: Dispatch<AppState>): ICancelExtractActionDropdownDispatchProps  {
  return {
    dispatchCancelExtractTaskAction: (itemInfo: ISpaceItemDetailInfo<'workbook' | 'datasource'>,
    extractCreationPending: boolean, encryptionActionType?: EncryptionActionType) => dispatch(cancelExtractAction([itemInfo], extractCreationPending, encryptionActionType))
  };
}

export const ConnectedCancelExtractActionDropdown = connect(null, mapDispatchToProps)(CancelExtractActionDropdown);
